import request from '@/utils/request';

export function getBirthdayInfo() {
  return request({
    url: '/Marketing/birthday2020',
  });
}

export function getBirthdayProductList(type) {
  return request({
    url: '/Marketing/birthdayProductList2020',
    params: {
      type,
    },
  });
}

export function getMessageWallInfo(type) {
  return request({
    url: '/Marketing/getMessage',
    params: {
      type,
    },
    silentRequest: true,
  });
}

export function createMessage(name, content, type) {
  return request({
    url: '/Marketing/createMessage',
    method: 'POST',
    data: {
      name,
      content,
      type,
    },
  });
}

export function receiveGift(data) {
  return request({
    url: '/Marketing/receiveBirthday2020Gift',
    method: 'POST',
    data,
  });
}

export function getBranchData(type) {
  return request({
    url: '/Marketing/birthday2020Branch',
    params: {
      type,
    },
  });
}

export function receiveBirthday2020Coupon(id) {
  return request({
    url: '/Marketing/receiveBirthday2020Coupon',
    method: 'POST',
    data: {
      id,
    },
  });
}
